/* eslint-disable */
"use strict";

import {ODUtil} from "./../../components/util.js";

var InfoPanel = function () {
    // Private properties
    var _element;

    // Private functions
    var _init = function() {
        ODUtil.scrollInit(_element, {
            disableForMobile: true,
            resetHeightOnDestroy: true,
            handleWindowResize: true,
            height: function() {
                var height = parseInt(ODUtil.getViewPort().height);

                height = height - 56.6; // header height
                height = height - parseInt(ODUtil.css(_element, 'paddingTop'));
                height = height - parseInt(ODUtil.css(_element, 'paddingBottom'));

                height = height - 2;

                return height;
            }
        });
    }

    // Public methods
    return {
        init: function(id) {
            _element = ODUtil.getById(id);

            if (!_element) {
                return;
            }

            // Initialize
            _init();
        },

        getElement: function() {
            return _element;
        }
    };
}();

// Webpack support
if (typeof module !== 'undefined') {
    // module.exports = ODLayoutQuickPanel;
}

export default InfoPanel;
